import React, { Component } from 'react';
import axios from 'axios';
import config from '../config';
import TwoFactorAuth from './TwoFactorAuth';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            invalid: true,
            email: '',
            password: '',
            isAuthenticated: false,
            showTwoFactorAuth: false,
            error: false,
            message: '',
            partialLoginToken: '',
            options: []
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.callback = this.callback.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);
        this.expiredCallback = this.expiredCallback.bind(this);
        this.forgotPwdButt = this.forgotPwdButt.bind(this);
    }

    componentDidMount() {
      //  parse query string
      let _ss = window.location.search;
      let _redirectURL = "";
      let _qs = null;
      if (typeof _ss !== 'undefined' && _ss.trim().length > 0) {
          //  check if the query string contains & character
          if (_ss.indexOf("&") >= 0) {
              // then split  with & too
              _qs = _ss.split("?")[1].split("&");
          }
          else {
              _qs = [];
              _qs.push(_ss.split("?")[1]);
          }

          let _query = [];
          _qs.forEach(function (item, index, array) {
              //console.log(item, index);
              let _k = item.split("=")[0]
              let _v = item.split("=")[1]
              let _item = {}
              _item[_k] = _v
              _query.push(_item)
          });
          // collect redirect url

          _query.forEach(function (item, index, array) {
              //console.log(item, index);
              for (var prop in item) {
                  if (item.hasOwnProperty(prop))
                      if (prop === 'redirectURL') {
                          _redirectURL = decodeURIComponent(item[prop]);
                      }
              }
          });
      }
      // let _redirectURL= decodeURIComponent(window.location.search.split("=")[1]);
      //console.log(_redirectURL);
      let redirectURL = null;
      if (typeof _redirectURL !== 'undefined') { redirectURL = _redirectURL } else { redirectURL = null }
      this.setState({
          searchString: _ss,
          redirectURL: redirectURL,
          subDomain:window.location.search
      });
      if (localStorage.isAuthenticated) {
          this.setState({
              isAuthenticated: true,
              token: localStorage.token,
              refreshToken: localStorage.refreshToken,
              redirectURL: redirectURL,
              subDomain:window.location.search
          });
      }
      if (localStorage.rememberMe === 'true') {
          this.setState({
              rememberMe: true,
          });
      }
  }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({ [name]: value });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!event.target.checkValidity()) {
            this.setState({ invalid: true, displayErrors: true });
            return;
        }
        this.setState({ invalid: false, displayErrors: false });

        const data = {
            email: this.state.email,
            password: this.state.password,
            domain: window.location.origin,
            subDomain: window.location.search
        };

        axios.post(`${config.API_BASE_URL}${config.API_LOGIN}`, data, { withCredentials: true })
            .then(response => {
                if (response.status === 200) {
                    const { partialLoginToken, options } = response.data;
                    if (this.state.rememberMe) {
                        localStorage.token = response.data.token;
                        localStorage.refreshToken = response.data.refreshToken;
                        localStorage.isAuthenticated = true;
                    }
                    this.setState({
                        partialLoginToken,
                        options,
                        isAuthenticated: true,
                        showTwoFactorAuth: true
                    });
                } else {
                    throw new Error(response.statusText);
                }
            })
            .catch(error => {
                let _msg = 'Oops, looks like you found a bug. Please try again in a new session.';
                if (error.response) _msg = error.response.data.message;
                this.setState({
                    error: true,
                    message: _msg,
                    rememberMe: false,
                    email: '',
                    password: '',
                    isRecaptchaAuthenticated: false,
                    token: '',
                    refreshToken: '',
                    isAuthenticated: false
                });
                localStorage.clear();
            });
    }

    callback() {

        // if(this.captcha){
        // grecaptcha.render('reCaptchSubmit', {
        //             'sitekey': config.RECAPTCHA_KEY,
        //             'callback': this.verifyCallback
        //         })
        //     }
    };
    // specifying verify callback function
    verifyCallback(response) {
        if (response) {
            this.setState({
                isRecaptchaAuthenticated: true
            })
        }
    };

    expiredCallback() {
        this.setState({
            isRecaptchaAuthenticated: false
        });
    }
    forgotPwdButt() {
        this.props.history.push(`/forgotpassword${window.location.search}`);
    }

    render() {
        const { email, password, error, message, isAuthenticated, showTwoFactorAuth, partialLoginToken, options, redirectURL,subDomain } = this.state;

        if (isAuthenticated && showTwoFactorAuth) {
            return (
                <div className="container">
                    <TwoFactorAuth email={email} partialLoginToken={partialLoginToken} options={options} redirectURL={redirectURL} subDomain={subDomain} />
                </div>
            );
        }

        return (
            <div className="container">
                <div className="card card-login mx-auto mt-5">
                    <div className="login-logo"></div>
                    <div className="login-header text-center">Login</div>
                    <div className="card-body">
                        {error &&
                            <div className="alert alert-danger">
                                <strong>Error! </strong>{message}
                            </div>
                        }
                        <form onSubmit={this.handleSubmit}>
                            <div className="form-group" id="html_element">
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="form-control custom-input username-input"
                                    placeholder="Email address *"
                                    required
                                    value={email}
                                    onChange={this.handleInputChange}
                                    maxLength="50"
                                    autoComplete="off" />
                            </div>
                            <div className="form-group">
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-control custom-input password-input"
                                    placeholder="Password *"
                                    required
                                    value={password}
                                    onChange={this.handleInputChange}
                                    maxLength="30" />
                            </div>
                            <div className="text-right mb-2">
                                <a className="small" href="javascript:void(0)" onClick={this.forgotPwdButt}>Forgot Password?</a>
                            </div>
                            <button className="btn btn-primary btn-block" type="submit">Login</button>
                        </form>
                    </div>
                    <div className="login-footer">
                        © 2024 Reliance Industries Limited. All rights reserved.
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js